import React, { Component } from 'react';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import { emptyString } from '../../../../ressources/functionJS/emptyString';
import { jsDictionaryEquals } from '../../../../ressources/functionJS/jsDictionaryEquals';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';
import { convertiUtsToDate, formatUniteArray } from '../GrapheXT/GrapheXT';

// Fonction utilitaire pour la couleur de ligne
function getLineColor(line_color) {
  const colorKey =
    line_color.startsWith('High ') || line_color.startsWith('Low ')
      ? line_color.split(' ')[1].toLowerCase()
      : line_color;
  switch (colorKey) {
    case 'black':
      return 'black';
    case 'red':
      return '#f70606';
    case 'amber':
      return '#ffa233';
    case 'blue':
      return '#3390ff';
    default:
      return 'green';
  }
}

// Fonction utilitaire pour générer le texte d'info-bulle
function generateTooltipText(name, values, unit, prefix, position) {
  return values.map((val) => {
    const label = !emptyString(prefix) ? prefix : `[${position}]`;
    return [name, `${label}: ${val} ${unit}`].join('<br>');
  });
}

// Fonction utilitaire pour construire une courbe Plotly
function buildCourbe({
  baseProps,
  x,
  y,
  text,
  type,
  name,
  line,
  xaxis,
  yaxis,
  legendgroup,
  showlegend,
  hovertemplate = '%{text}<extra></extra>',
}) {
  return {
    ...baseProps,
    x,
    y,
    text,
    type,
    name,
    line,
    xaxis,
    yaxis,
    legendgroup,
    showlegend,
    hovertemplate,
  };
}

class Graphes2 extends Component {
  state = {
    data: [],
    layout: {},
  };

  render() {
    let layout = {};
    let data = [];
    if (
      this.props.configuration !== undefined &&
      this.props.donnees !== undefined
    ) {
      layout = {
        legend: {
          orientation: 'h',
          font: {
            size: 14,
          },
        },
        font: { size: 14 },
        title: {
          text:
            this.props.configuration.title +
            '<br>' +
            this.props.configuration.subtitle,
          font: {
            // size: 25,
            color: '#3c3935',
          },
        },
        barmode: this.props.configuration.barmode,

        yaxis1: { domain: [0.55, 1], anchor: 'x1' },
        xaxis1: {
          domain: [0, 1],
          anchor: 'y1',
          type: 'date',
        },

        yaxis2: { domain: [0, 0.45], anchor: 'x2' },
        xaxis2: {
          domain: [0, 1],
          anchor: 'y2',
          type: 'date',
        },
        ...(this.props.viewobj_json_content === undefined ||
        this.props.viewobj_json_content === null
          ? {}
          : this.props.viewobj_json_content.layout),
      };

      if (this.props.configuration.xaxis.title.indexOf('#full_date#') > -1) {
        layout.xaxis1['tickmode'] = 'linear';
        layout.xaxis1['tickformat'] = '%d/%m';
        layout.xaxis2['tickmode'] = 'linear';
        layout.xaxis2['tickformat'] = '%d/%m';
        layout.yaxis1['tickfont'] = { size: 20 };
        layout.yaxis2['tickfont'] = { size: 20 };
        layout.xaxis1['tickfont'] = { size: 20 };
        layout.xaxis1['tickangle'] = 50;
        layout.xaxis2['tickfont'] = { size: 20 };
        layout.xaxis2['tickangle'] = 50;
      }

      //mise en forme des données de composantes de capteurs
      for (
        let indSetDonnees = 0;
        indSetDonnees < this.props.donnees.length;
        indSetDonnees++
      ) {
        const donnees = this.props.donnees[indSetDonnees];
        switch (donnees.yaxis) {
          case 'y1':
            layout['yaxis1']['title'] = donnees.engineering_unit;
            break;
          case 'y2':
            layout['yaxis2']['title'] = donnees.engineering_unit;
            break;
          case 'y3':
            layout['yaxis3']['title'] = donnees.engineering_unit;
            break;
          case 'y4':
            layout['yaxis4']['title'] = donnees.engineering_unit;
            break;
          default:
            layout['yaxis1']['title'] = donnees.engineering_unit;
        }

        // Utilisation de la fonction utilitaire pour générer le texte d'info-bulle
        const text = generateTooltipText(
          donnees.sensor_name,
          donnees.y,
          donnees.engineering_unit,
          donnees.prefix,
          donnees.position_in_sensor
        );

        //converti l'axe des uts en date format plotly (exemple: "2013-10-04 22:23:00")
        const timeAxis = convertiUtsToDate(donnees.x);
        const valeurAxis = formatUniteArray(
          donnees.y,
          donnees.engineering_unit
        );

        let name = donnees.name;
        if (donnees.name === '') {
          name =
            donnees.prefix !== '' ? donnees.prefix : donnees.position_in_sensor;
        }

        let type = donnees.type === 'bar' ? 'bar' : 'scatter';
        if (this.state.afficherManuelMode === true) {
          type = this.state.afficherModeBar === true ? 'bar' : 'scatter';
        }

        const courbe = buildCourbe({
          baseProps: donnees,
          xaxis: donnees.yaxis.replace('y', 'x'),
          yaxis: donnees.yaxis,
          x: timeAxis,
          y: valeurAxis,
          text: text,
          type,
          name,
        });

        data.push(courbe);
      }

      //mise en forme des données des seuils de composantes
      for (
        let indSetSeuils = 0;
        indSetSeuils < this.props.seuils.length;
        indSetSeuils++
      ) {
        if (
          this.props.seuils[indSetSeuils].show_alarms === undefined ||
          parseInt(this.props.seuils[indSetSeuils].show_alarms) === 1
        ) {
          let afficherDansLegende = true;
          for (
            let indSeuil = 0;
            indSeuil < this.props.seuils[indSetSeuils].data.length;
            indSeuil++
          ) {
            const seuilData = this.props.seuils[indSetSeuils].data[indSeuil];
            if (
              !(
                jsDictionaryEquals(seuilData.x, null) ||
                jsDictionaryEquals(seuilData.x, [null]) ||
                jsDictionaryEquals(seuilData.x, [null, null]) ||
                jsDictionaryEquals(seuilData.x, undefined) ||
                jsDictionaryEquals(seuilData.x, '') ||
                jsDictionaryEquals(seuilData.y, null) ||
                jsDictionaryEquals(seuilData.y, [null]) ||
                jsDictionaryEquals(seuilData.y, [null, null]) ||
                jsDictionaryEquals(seuilData.y, undefined) ||
                jsDictionaryEquals(seuilData.y, '')
              )
            ) {
              const sensorName =
                '[' +
                checkMot('alarme') +
                ']' +
                (!emptyString(this.props.seuils[indSetSeuils].name)
                  ? this.props.seuils[indSetSeuils].name
                  : this.props.seuils[indSetSeuils].sensor_name);

              const text = generateTooltipText(
                sensorName,
                seuilData.y || [],
                this.props.seuils[indSetSeuils].engineering_unit,
                this.props.seuils[indSetSeuils].prefix,
                this.props.seuils[indSetSeuils].position_in_sensor
              );

              const x = convertiUtsToDate(seuilData.x);
              const y = formatUniteArray(
                seuilData.y,
                seuilData.engineering_unit
              );

              const linecolor = getLineColor(seuilData.line_color);

              const courbe = buildCourbe({
                baseProps: {
                  ...this.props.seuils[indSetSeuils],
                  ...seuilData,
                },
                x,
                y,
                text,
                type: 'scatter',
                name:
                  '[' +
                  checkMot('alarme') +
                  '] ' +
                  this.props.seuils[indSetSeuils].sensor_name,
                line: {
                  ...seuilData.line,
                  color: linecolor,
                  dash: 'solid',
                },
                legendgroup: this.props.seuils[indSetSeuils].sensor_name,
                showlegend: afficherDansLegende,
              });

              data.push(courbe);
              afficherDansLegende = false; //affiche que la première légende groupé
            }
          }
        }
      }
    }

    return (
      <BibliothequePlotly
        data={data}
        layout={{
          ...layout,
          responsive: true,
          showlegend: true,
          ...this.props.viewobj_json_content,
        }}
        ouvrirPopupModifierIntervalle={
          this.props.switchAfficherModifierIntervalle
        }
        dimensionWidth={this.props.dimensionWidth}
        dimensionHeight={this.props.dimensionHeight}
        viewobj_json_content={this.props.viewobj_json_content}
      />
    );
  }
}

export default Graphes2;
